import { HTTP } from "../helpers/http-common.js";
import authHeader from "../helpers/auth-header";
import helpers from "../helpers/helpers";

const webOrdersService = {
  getWebOrders,
  storeWebOrder,
  updateWebOrder,
  webOrderToInvoice,
  deleteWebOrder
};

export default webOrdersService;

function getWebOrders(page = 1, search) {
  let params = "";

  if (search.term) {
    params += `&search=${search.term}`;
  }

  if(search.rangeDates) {
    params += `&rangeDates=${search.rangeDates}`
  }

  if (search.options) {
    params += `&options=${search.options}`;
  }

  if (search.perPage) {
    params += `&perPage=${search.perPage}`;
  }

  return HTTP.get(`web-orders?page=${page}${params}`, {
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function storeWebOrder(webOrder = {}) {
  return HTTP({
    method: "post",
    url: "store-web-order",
    data: webOrder,
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function updateWebOrder(webOrder = {}) {
  return HTTP({
    method: "post",
    url: "update-web-order",
    data: webOrder,
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function webOrderToInvoice(id) {
  return HTTP({
    method: "post",
    url: "web-order-to-invoice",
    data: { id: id },
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}

function deleteWebOrder(id) {
  return HTTP({
    method: "post",
    url: "delete-web-order",
    data: { id: id },
    headers: {
      Authorization: authHeader(),
      "x-Company": helpers.getCompanyId()
    }
  });
}